module.exports = __webpack_public_path__ + "img/glogo23.ffd9ef87.png";